import { API_BASE } from './client.js';

export const loginUrl = `${API_BASE}/auth/login`;

/** Signs in and comes back to `path` rather than to the lobby's front door. */
export const loginReturningTo = (path: string): string =>
  `${loginUrl}?returnTo=${encodeURIComponent(new URL(path, location.origin).href)}`;
